// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* tbd override */\n.floater_table__keyword[data-v-1a8cd098] {\n  height: 150px;\n  padding: 8px;\n  font: 14px / 20px 'Noto Sans JP';\n}\n.floater_table__body div[data-v-1a8cd098] {\n  height: initial;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
